import {
    PRODUCT_STATUS_D,
    PRODUCT_STATUS_DISMISSED,
    PRODUCT_STATUS_DRAFT,
    PRODUCT_STATUS_R,
    PRODUCT_STATUS_READY,
    PRODUCT_STATUS_X,
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";


export const useStatusValuesProduct = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColorProduct = (status: string) => {
        switch (status) {
            case PRODUCT_STATUS_D:
            case PRODUCT_STATUS_DRAFT: return theme.palette.warning.transparent;
            case PRODUCT_STATUS_R:
            case PRODUCT_STATUS_READY: return theme.palette.success.transparent;
            case PRODUCT_STATUS_X:
            case PRODUCT_STATUS_DISMISSED: return theme.palette.error.transparent;
        }
    };

    const getStatusLabelProduct = (status: string) => {
        switch (status) {
            case PRODUCT_STATUS_D:
            case PRODUCT_STATUS_DRAFT: return t('salesmarketing:product.status.draft');
            case PRODUCT_STATUS_R:
            case PRODUCT_STATUS_READY: return t('salesmarketing:product.status.ready');
            case PRODUCT_STATUS_X:
            case PRODUCT_STATUS_DISMISSED: return t('salesmarketing:product.status.dismissed');
            default: return ''
        }
    };

    return {
        getStatusColorProduct,
        getStatusLabelProduct
    }
}